// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3CvOh","right":"styles_right__2Tgvk"};